import { wsService } from "./wsService";

const section = "rules/reposicion";

function filter(param = { enable: true }) {
  return wsService.make_post_request(section + "/list", param);
}

function get(param = {}) {
  return wsService.make_post_request(section + "/get", param);
}

function create(param = {}) {
  return wsService.make_post_request(section + "/create", param);
}

function update(param = {}) {
  return wsService.make_put_request(section + "/update", param);
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}

function download_excel(param = {}) {
  return wsService.make_post_request(section + "/get-sample-excel", param);
}

function import_line_excel(param = {}) {
  return wsService.make_post_request(section + "/import-line", param);
}

function generar_reposicion(param = {}) {
  return wsService.make_post_request(section + "/generar-reposicion", param);
}

function generar_reposicion_estado(param = {}) {
  return wsService.make_post_request(section + "/generar-reposicion-estado", param);
}

export const reposicionRuleService = {
  section,
  filter,
  get,
  remove,
  create,
  update,
  download_excel,
  import_line_excel,
  generar_reposicion,
  generar_reposicion_estado,
};
